import styled from "styled-components";
export const MainApp = styled.div``;
export const AppHeader = styled.header``;
